import { useTranslation } from "react-i18next"
import { IconButton } from "../../../../../../components"
import PropTypes from "prop-types"
import React from "react"

import { formatPhone } from "../../../../../../utils/format"

export const AddressTable = props => {
  const { t } = useTranslation()

  return (
    <div className="table-responsive">
      <table className="table align-middle table-cell_p-v_sm">
        <tbody>
          {props.items.map(item => (
            <tr key={item.id}>
              <td>
                <div className={"d-flex-col"}>
                  <div className={"mb-1 fw-bold"}>
                    {item.main_type ? t("main") : null}
                  </div>
                  <div className={"text-black fw-bold "}>
                    {item.billing_type ? t("billing") : null}
                  </div>
                </div>
              </td>
              <td>
                <div className={""}>
                  <div className={"text-black"}>
                    {`${item.zip || ""} ${item.street} ${item.town}`}
                  </div>
                </div>
              </td>
              <td>
                <div className={"d-flex-col text-nowrap"}>
                  <div>
                    <span className={"text-black fw-bold"}>
                      {t("telephone") + ":"}
                    </span>{" "}
                    <span>{formatPhone(item.phone)}</span>
                  </div>
                  <div>
                    <span className={"text-black fw-bold"}>
                      {t("email") + ":"}
                    </span>{" "}
                    <span>{item.email}</span>
                  </div>
                </div>
              </td>
              <td
                className={"table-column-sticky_end bg-neutral text-nowrap"}
                style={{ width: "76px" }}
              >
                <IconButton
                  name={"edit"}
                  bg
                  onClick={() => props.onEdit(item)}
                  disabled={props.removingLoading}
                />
                <IconButton
                  name={"remove"}
                  bg
                  onClick={() => props.onRemove(item)}
                  wrapClass={"ms-2"}
                  disabled={props.removingLoading}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

AddressTable.propTypes = {
  items: PropTypes.array,
  removingLoading: PropTypes.bool,

  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
}
